"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyGroupJoin = void 0;
const utilityFunctions_1 = require("../../utilities/utilityFunctions");
function applyGroupJoin(factory, outer, inner, outerKeySelector, innerKeySelector, resultSelector, equalityComparer) {
    function* generator() {
        if (equalityComparer) {
            for (const outerItem of outer) {
                const outerKey = outerKeySelector(outerItem);
                const inners = factory
                    .createBasicEnumerable((0, utilityFunctions_1.getIterableGenerator)(inner))
                    .where(innerItem => equalityComparer(outerKey, innerKeySelector(innerItem)));
                yield resultSelector(outerItem, inners);
            }
        }
        else {
            const innerMap = new Map();
            for (const innerItem of inner) {
                const key = innerKeySelector(innerItem);
                const curr = innerMap.get(key);
                if (curr !== undefined) {
                    curr.push(innerItem);
                }
                else {
                    innerMap.set(key, [innerItem]);
                }
            }
            for (const outerItem of outer) {
                const key = outerKeySelector(outerItem);
                const innersToJoin = innerMap.get(key);
                yield resultSelector(outerItem, factory.createBasicEnumerable((0, utilityFunctions_1.getIterableGenerator)(innersToJoin !== null && innersToJoin !== void 0 ? innersToJoin : [])));
            }
        }
    }
    return factory.createBasicEnumerable(generator);
}
exports.applyGroupJoin = applyGroupJoin;
//# sourceMappingURL=applyGroupJoin.js.map